<template>
    <div class="">
        <div class="p-0" style="display: block;" v-if="isPageOpened()">
            <div class="tab-content mt-2">
                <div class="panel">
                    <div class="reports_container">
                        <v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
                            <div class="row" style="display: flex; justify-content: space-between" >
                                <div class="col-4" style="display: flex; align-items: center;">
                                    <div class="custom-icon-wrapper m-2" style="display: inline-block"> <v-icon @click="backToAdminPage">custom-icon left-arrow-icon</v-icon> </div>
                                    <v-toolbar-title  class="size-16 dark-text mx-3" >{{ $t("res_Label_AuditTrail") }} ({{ this.reports.length }})</v-toolbar-title >
                                </div> 
                            </div>
                        </v-toolbar>
                        <div class="grid-4-items mt-4">
                            <v-card class="" v-for="item in this.reports" :value="item.id" :key="item.id" @click="openReport(item.id)" >
                                <!-- <v-chip dark class="mb-3" color="purple">category</v-chip> -->
                                <h3 v-if="lang=='en'" class="dark-title pb-2">{{ item.titleEn }}</h3>
                                <h3 v-else class="dark-title font-weight-bold pb-2">{{ item.titleAr }}</h3>
                                <p class="m-0" v-if="lang=='en'">{{ item.descriptionEn }}</p>
                                <p class="m-0" v-else>{{ item.descriptionAr }}</p>
                            </v-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants';
import Report from '@/views/Reports/Report.vue'
import router from '@/router/index.js'

export default {
    name: 'AuditTrails',
    components: { Report },
    data: function () {
        return {
            reports: [],
            lang: 'en',
        };
    },
    methods: {
        backToAdminPage()
        {
            router.push({ name: 'admin' })
        },
        isPageOpened() 
        {
            return this.$route.name === 'AuditTrails'
        },
        getReports() 
        {
            axios.get(constants.baseApiUrl + "Report/GetReports?applicationId="+window.defaultApplicationId + '&showAuditReports=true', { headers: constants.headers })
                .then((res) => this.reports = res.data)
                .catch((err) => console.log(err));
        },
        openReport: function (reportId) 
        {
            var selectedReport = this.reports.find((obj) => obj.id === reportId);
            if (selectedReport != null) 
            {
                router.push({ name: 'audit', query: { id: selectedReport.id} })
            }
        },
    },
    mounted() 
    {
        this.lang = 'en'
        if (localStorage.getItem('lang') != null)
            this.lang = localStorage.getItem('lang')

        const intervalId = setInterval(() => 
        {
            if (constants.isPermissionsLoaded == true) 
            {
                clearInterval(intervalId);
                this.getReports();
            }
        }, 100);
    }
}
</script>

<style scoped>
.v-card {
    box-shadow: 0px 12px 24px rgb(0 0 0 / 8%) !important;
    border: 0;
    border-radius: 12px;
    padding: 1rem;
}
</style>